import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const fetchSocialStats = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data: { url: string }) => {
    const url = String(data?.url ?? "").trim();
    if (!url) throw new Error("A social profile link is required.");
    return { url };
  })
  .handler(async ({ data }) => {
    const { fetchSocialProfile } = await import("./social.server");
    return fetchSocialProfile(data.url);
  });

export const fetchPostPreviewFn = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data: { url: string }) => {
    const url = String(data?.url ?? "").trim();
    if (!url) throw new Error("A post link is required.");
    if (url.length > 500) throw new Error("That link is too long.");
    return { url };
  })
  .handler(async ({ data }) => {
    const { fetchPostPreview } = await import("./social.server");
    return fetchPostPreview(data.url);
  });
